module.exports = __webpack_public_path__ + "img/jiazhang.f04865bb.png";